import React from "react";
import { Image, StyleSheet, Text, View } from "react-native";

import { MaterialIcons } from "@expo/vector-icons";

export default function ModalSuccess({ handleCloseModal, text, textColor, subtitle, img, positionHeader }) {
  return (
    <>
      <View style={
        positionHeader !== undefined ?
          positionHeader === 'left' ?
            styles.headerLeft :
            styles.headerRight : styles.headerLeft
      }
      >
        <MaterialIcons
          onPress={handleCloseModal}
          name="close"
          size={30}
          color="black"
        />
      </View>
      <View style={styles.container}>
        {
          img !== undefined ?
            img === 1 ? (
              <Image
                source={require("../../assets/rocket.png")}
                style={styles.image1}
              />
            ) :
              img === 2 ? (
                <Image
                  source={require("../../assets/success.png")}
                  style={styles.image2}
                />
              ) : <></>
            : <></>
        }
        <Text style={styles.text}>
          {text}{" "}
          <Text style={styles.success}>{textColor}</Text>
        </Text>

        {
          subtitle !== undefined ? (
            <Text
              style={{
                fontWeight: "bold",
                textAlign: "center",
                fontSize: 12,
                marginTop: 25,
              }}
            >
              {subtitle}
            </Text>
          ) : <></>
        }

      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "5%",
  },
  headerLeft: {
    marginTop: 25,
    padding: 15,
    alignItems: "flex-start",
  },
  headerRight: {
    marginTop: 25,
    padding: 15,
    alignItems: "flex-end",
  },
  image1: { width: 150, height: 300 },
  image2: { width: 90, height: 90 },
  text: {
    fontSize: 16,
    marginTop: 30,
    textAlign: "center",
  },
  success: {
    fontWeight: "bold",
    color: "#2797A2",
  },
});
